export const Auth = {
  _accessKey: 'token',
  API_URL: import.meta.env.VITE_API_URL,

  get accessToken() {
    return localStorage.getItem(Auth._accessKey)
  },
  set accessToken({ token, expiration }) {
    if (import.meta.env.MODE === 'development') {
      localStorage.setItem(Auth._accessKey, token)
    }
    Auth.setCookie({ name: 'client_key_v2', value: token, seconds: expiration })
  },
  clearAccessToken() {
    localStorage.clear(Auth._accessKey)
    // Remove token from auth cookie - use same fn so path etc. are exactly the same
    Auth.setCookie({ name: 'client_key_v2', value: '', seconds: -20 })
  },
  setCookie({ name, value, seconds }) {
    let expires = ''
    const date = new Date()
    date.setTime(date.getTime() + 1000 * seconds)
    expires = '; expires=' + date.toUTCString()
    document.cookie = name + '=' + (value || '') + expires + '; path=/; Secure; SameSite=Lax'
  },
  logout: () => {
    Auth.clearAccessToken()
  }
}
